export default "__VITE_ASSET__BaS7ELrh__"